import script from "./RoomLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoomLayout.vue?vue&type=script&setup=true&lang=ts"

import "./RoomLayout.vue?vue&type=style&index=0&id=63c21362&lang=scss&scoped=true"
import "./RoomLayout.vue?vue&type=style&index=1&id=63c21362&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63c21362"]])

export default __exports__